if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        this.preferAvailableVariant(event.target);
        const target = this.getInputForEventTarget(event.target);
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { data: { selectedOptionValues: this.selectedOptionValues, event, target } });
      });
    }

    // Enova: al cambiar una opción (p. ej. el color), si la combinación con las opciones siguientes
    // (la talla) está agotada, se marcan las de la primera variante disponible. Así no se queda en
    // «Agotado» porque la talla anterior no existe en el nuevo color. Elegir a propósito una talla
    // agotada (la última opción) no cambia nada.
    preferAvailableVariant(target) {
      const data = this.querySelector('script[data-enova-variants]');
      const fields = Array.from(this.querySelectorAll('[data-picker-field]'));
      const index = fields.indexOf(target.closest('[data-picker-field]'));
      if (!data || index < 0 || index === fields.length - 1) return;

      let variants;
      try {
        variants = JSON.parse(data.textContent);
      } catch (error) {
        return;
      }

      const valueOf = (field) => {
        const select = field.querySelector('select');
        if (select) return select.value;
        const checked = field.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      };
      const current = fields.map(valueOf);
      const match = variants.find((variant) => variant.options.every((value, i) => value === current[i]));
      if (match && match.available) return;

      const alternative = variants.find(
        (variant) => variant.available && variant.options.slice(0, index + 1).every((value, i) => value === current[i])
      );
      if (!alternative) return;

      fields.forEach((field, i) => {
        if (i <= index) return;
        const select = field.querySelector('select');
        if (select) {
          select.value = alternative.options[i];
          return;
        }
        const radio = Array.from(field.querySelectorAll('input[type="radio"]')).find((input) => input.value === alternative.options[i]);
        if (radio) radio.checked = true;
      });
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
  }
  customElements.define("variant-picker", VariantPicker);
}